module.exports = __webpack_public_path__ + "static/media/logo.6a64547f.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/nav/logo.png
// module id = 658
// module chunks = 0